import { useState, useEffect } from "react";
import { X, Sparkles, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const SetupNudge = () => {
  const { user, ready } = useAuth();
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem("wardogs_setup_nudge_dismissed"));
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), 400);
    return () => clearTimeout(t);
  }, []);

  if (!ready || !user || user === false) return null;
  if (user.onboarding_completed !== true) return null; // new users are handled by the wizard
  const missing = !user.faction || !user.steam_id;
  if (!missing || dismissed) return null;

  const open = () => window.dispatchEvent(new CustomEvent("open-welcome-wizard"));
  const dismiss = () => { localStorage.setItem("wardogs_setup_nudge_dismissed", "1"); setDismissed(true); };

  const msg = !user.faction && !user.steam_id
    ? "Pick a faction and link Steam to unlock stats tracking."
    : !user.steam_id
      ? "Link your Steam to start tracking kills, wins & XP."
      : "Pick a faction to rep your allegiance.";

  return (
    <div
      data-testid="setup-nudge"
      className={`fixed bottom-4 right-4 left-4 sm:left-auto z-40 sm:w-[360px] flex items-center gap-3 bg-gradient-to-r from-[#1a1710] to-[#13151B] border border-[#D4A94A]/40 tactical-frame-sm px-4 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.55)] transition-all duration-300 ${shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <Sparkles className="w-4 h-4 text-[#D4A94A] shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-stencil font-black uppercase text-sm text-[#F1F5F9]">Finish setting up your dossier</div>
        <div className="font-mono text-[11px] text-[#94A3B8] truncate">{msg}</div>
      </div>
      <button data-testid="setup-nudge-resume" onClick={open} className="shrink-0 inline-flex items-center gap-1 bg-[#D4A94A] hover:bg-[#E5BD60] text-[#0B0C0E] font-stencil font-black uppercase text-xs px-3 py-2 tactical-frame-sm transition-colors">Finish setup <ChevronRight className="w-3.5 h-3.5" /></button>
      <button data-testid="setup-nudge-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 text-[#64748B] hover:text-[#F1F5F9] transition-colors"><X className="w-4 h-4" /></button>
    </div>
  );
};

export default SetupNudge;
